import React, { useEffect, useRef, useState } from "react";
import { FileUpload } from 'primereact/fileupload';
import fetchMethodRequest from '../../../config/service';
import showToasterMessage from '../../../containers/UI/ToasterMessage/toasterMessage';
import config from '../../../config/config';
import configImages from '../../../config/configImages';
import { Link } from 'react-router-dom';
import ImageWithPoints from "../../../config/configData";

const DoFileUpload = (props) => {
    const fileInputRef = useRef(null);
    const [point, setPoint] = useState(null);

    const id = props.id ? props.id : props.name;
    let label = props.label ? props.label : '';
    let newFiles = props.field.value;
    let isMultiple = props.isMultiple ? props.isMultiple : false;
    let type = props.type;
    const maxFiles = 5;

    useEffect(() => {
        setPoint(props.annotations);
    }, [props.annotations]);

    const onSelect = (e) => {
        const selectedFiles = isMultiple ? e.files : e.files[0];

        uploadFilesToServer(selectedFiles);
        setPoint({});
    }

    const upload = (e) => {
        const files = e.files;
        // if (files.length > maxFiles) {
        //     showToasterMessage(`You can only upload ${maxFiles} files`, 'error')
        //     const fileInput = document.querySelector('.p-fileupload-content');
        //     if (fileInput) {
        //         fileInput.style.display = 'none';
        //     }
        // } else {
        uploadFilesToServer(isMultiple ? e.files : e.files[0]);
        setPoint({})
        // }
    }

    const uploadFilesToServer = (data) => {
        fetchMethodRequest('POST', props.url, data, 'upload', isMultiple)
            .then(async (response) => {
                if (response && response.respCode) {
                    let fileName = response?.fileName;
                    //Setting field value in form
                    if (props.field && !isMultiple) {
                        props.field.onChange([fileName[0].name])
                    } else {
                        let newFiles = fileName.map(file => file.name);
                        let existingFiles = props.field.value || [];
                        let allFiles = [...existingFiles, ...newFiles];
                        if (props.field) {
                            props.field.onChange(allFiles)
                        }
                        clearFileUpload();
                    }
                    if (props.type === 'profile') {
                        let data = JSON.parse(localStorage.getItem('loginCredentials'))
                        data.photo = fileName;
                        localStorage.setItem('loginCredentials', JSON.stringify(data))
                    }
                    showToasterMessage(response.respMessage, 'success');
                } else if (response && response.errorMessage) {
                    showToasterMessage(response.errorMessage, 'error');
                } else {
                    showToasterMessage('upload failed')
                }
            }).catch((err) => {
                return err;
            });
    }

    const checkImg = (img) => {
        if (img) {
            return config.imageFormats.some(x => img.toLowerCase().includes(x));
        }
        return false;
    };

    const deleteFile = (img) => {
        if (img) {
            let allFiles = newFiles.filter(file => file !== img);
            props.field.onChange(allFiles);
            clearFileUpload();
        }
    };

    const clearFileUpload = () => {
        if (fileInputRef.current) {
            fileInputRef.current.clear();
        }
    };

    const handleClick = (e) => {
        const rect = e.target.getBoundingClientRect();
        const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
        const yPercent = ((e.clientY - rect.top) / rect.height) * 100;
        const point = { xPercent, yPercent };

        setPoint(point);
        props.onChange(point);
    };


    return (
        <div className='d-flex flex-column'>
            <div className="flex align-center">
                <label htmlFor={id} className="text-capitalize">{label}</label>
            </div>
            <FileUpload
                ref={fileInputRef}
                mode={isMultiple ? 'advanced' : 'basic'}
                name={props.name ? props.name : 'file'}
                accept={props.acceptType ? props.acceptType : '*'}
                onSelect={!isMultiple ? onSelect : ''}
                customUpload
                uploadHandler={upload}
                multiple={isMultiple ? isMultiple : false}
                chooseLabel={props.label ? props.label : 'Choose File'}
            />
            <div>
                {newFiles && newFiles.length > 0 && (
                    <div className="d-flex flex-wrap">
                        {newFiles.map(img => (
                            <div className="row w-50" >
                                <div className="col-7 my-2">
                                    {props.type === 'profile' ?
                                        (<Link to={`${config.profileUrl}${img}`} target="_blank">
                                            <img src={config.profileUrl + img} style={{ width: '100%', height: '100%' }} alt="" />
                                        </Link>) :
                                        props.type === 'AccessPoints' ?
                                            <div
                                                style={{ position: 'relative', width: '52rem' }}
                                                onClick={handleClick}
                                            >
                                                <ImageWithPoints imageUrl={`${config.imgUrl}${type.toLowerCase()}/${img}`} points={point} />
                                            </div>
                                            :
                                            checkImg(img) ? (
                                                <Link to={`${config.imgUrl}${type.toLowerCase()}/${img}`} target="_blank">
                                                    <img src={config.imgUrl + `${type.toLowerCase()}/` + img} style={{ width: '80%' }} alt="" />
                                                </Link>
                                            ) : (
                                                <a href={`${config.imgUrl}${type.toLowerCase()}/${img}`} target='_blank' >
                                                    <img title={img} src={configImages?.[img?.split('.')?.[img?.split('.')?.length - 1]]} alt="" />
                                                </a>
                                            )}
                                </div>
                                {/* <div className="col-4 my-3">
                                    <button className="btn text-danger" type='button' onClick={() => deleteFile(img)} style={{ padding: '5px 10px' }}>
                                        <i className="pi pi-trash" />
                                    </button>
                                </div> */}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <small className="text-danger " style={{ marginTop: "5px" }}>{props.fieldState?.invalid ? props.errors[props.name]?.message : ''}</small>  {/* commenting for now  */}
        </div>
    );
};
export default DoFileUpload;